import { landingPageScreen_Query } from "@generated/landingPageScreen_Query.graphql";
import { useLazyLoadQuery } from "react-relay";
import { NavLink, useMatch } from "react-router-dom";
import { QUERY } from "./landing-page-screen.graphql";
import {
	BodyContainer,
	ContentCard,
	DescrContainer,
	Header,
	ImageWrapper,
	LogoWrapper,
	PageContainer,
	TitleTag,
	WrapperContainer,
	Image,
} from "./landing-page-screen.styles";
import Wissenwirkt from "../../../infecto-lms-webapp-impl/assets/logo.png";
import { NodeCard } from "../../../infecto-lms-webapp-impl/components/NodeCard.component";
import { DASHBOARD_PATH } from "../../../infecto-lms-webapp-impl/router/routes/auth/dashboard.routes";
import { LANDING_PAGE_PATH } from "../../../infecto-lms-webapp-impl/router/routes/non-auth/landing-pages.routes";
import { NodeCardsContainer } from "../../components/UserStartedTreesStates.component";

export function LandingPageScreen() {
	const {
		params: { urlParam },
	} = useMatch(LANDING_PAGE_PATH)!;
	const query = useLazyLoadQuery<landingPageScreen_Query>(QUERY, {
		filterByUrlParam: urlParam!,
	});
	const result = query.SingleLandingPageV2.singleLandingPage.edges!.map((e) => e!.node!);

	return (
		<div style={{ width: "100%" }}>
			{result.length > 0 ? (
				<PageContainer key={result[0].urlParam}>
					<Header>
						<NavLink to={DASHBOARD_PATH}>
							<LogoWrapper>
								<Image imageurl={Wissenwirkt} />
							</LogoWrapper>
						</NavLink>
					</Header>

					<BodyContainer className="surface-100">
						<ContentCard className="shadow-1">
							<TitleTag>{result[0].title}</TitleTag>
							<WrapperContainer>
								{result[0].description && (
									<DescrContainer dangerouslySetInnerHTML={{ __html: result[0].description }} />
								)}
								{result[0].image !== null && (
									<ImageWrapper>
										<Image imageurl={result[0].image!.url} />
									</ImageWrapper>
								)}
							</WrapperContainer>
						</ContentCard>
						<div className="grid mt-2 mb-4">
							{/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
							{result[0].rootNodes?.edges?.map((rootNode: any) =>
								rootNode ? (
									<NodeCardsContainer key={rootNode.node.id} className="lg:col-4 col-12">
										<NodeCard
											nodeWithoutUserLearnStateFragmentRef={rootNode.node}
											ignoreUserLearnState={true}
										/>
									</NodeCardsContainer>
								) : null,
							)}
						</div>
					</BodyContainer>
				</PageContainer>
			) : null}
		</div>
	);
}
